import { css } from "styled-components";
import token from "styled-token";
import { StyledIcon } from "../../components/Icon/Icon";
/** @class AvatarBadgeMixin */

/** @method */

export var AvatarBadgeMixin = function AvatarBadgeMixin(props) {
  var size = props.size;
  return token({
    badgeSize: "AvatarBadge.badgeSizes." + size,
    backgroundColor: "AvatarBadge.backgroundColor",
    borderRadius: "radii.ellipse",
    borderColor: "AvatarBadge.borderColor",
    color: "AvatarBadge.foregroundColor",
    iconSize: "AvatarBadge.iconSizes." + size
  }, function (_ref) {
    var badgeSize = _ref.badgeSize,
        backgroundColor = _ref.backgroundColor,
        borderRadius = _ref.borderRadius,
        borderColor = _ref.borderColor,
        color = _ref.color,
        iconSize = _ref.iconSize;
    return css(["height:", "px;width:", "px;box-sizing:border-box;background-color:", ";border-radius:", ";border:2px solid ", ";color:", ";display:flex;justify-content:center;align-items:center;", "{height:", "px;width:", "px;}"], badgeSize, badgeSize, backgroundColor, borderRadius, borderColor, color, StyledIcon, iconSize, iconSize);
  })(props);
};